export const reorder = (list: any[], startIndex: number, endIndex: number) => {
    const items = [...list];
    const [removed] = items.splice(startIndex, 1);
    items.splice(endIndex, 0, removed);
    return items;
};
